import React from 'react'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import i18next from 'i18next'

function withPreventNavigation(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return class extends React.Component {
    state = {
      removeLeaveHook: null
    }

    constructor(props) {
      super(props)
    }

    componentDidMount() {
      // This makes sure that current React route cannot be exited without a prompt, save remove function to state
      this.setState({
        removeLeaveHook: this.props.router.setRouteLeaveHook(this.props.route, () =>
          this.routerWillLeave()
        )
      })

      // This makes sure that a prompt is shown before navigating away from current page
      window.addEventListener('beforeunload', this.preventBrowserNavigation)
    }

    componentWillUnmount() {
      this.state.removeLeaveHook()
      window.removeEventListener('beforeunload', this.preventBrowserNavigation)
    }

    /**
     * React Route leave handler, will interrupt navigation with a prompt if questionnaire is in progress
     * @returns Text content for the prompt
     */
    routerWillLeave = () => {
      if (!this.props.isFinished) {
        return i18next.t('leaving_test_in_progress', {
          lng: this.props.language,
          ns: 'questionnaire'
        })
      }
    }

    /**
     * Browser navigation handler, will interrupt browser navigation with a prompt if questionnaire is in progress
     * @param event Beforeunload event
     */
    preventBrowserNavigation = event => {
      if (!this.props.isFinished) {
        event.preventDefault()
        event.returnValue = ''
      }
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}

export default compose(withRouter, withPreventNavigation)



// WEBPACK FOOTER //
// ./src/components/hocs/withPreventNavigation.js